import { SignRepository } from '../../domain/repositories/sign.repository';

// Services
import { http } from '../plugins/http/http';

// Models
import { ISignTemplate } from '../../domain/models/IZohoSign';

export const signRepository = (): SignRepository => ({
  getDocInfo: async (docId: string) => {
    try {
      const response = await http.cleanGet('/signdoc/documentinfo', { docId });
      return response;
    } catch (error) {
      return 'invalidFile';
    }
  },
  getTemplateInfo: async (docId: string) => {
    const response = await http.cleanGet('/signdoc/templateinfo', { docId });
    return response;
  },
  getSignUrl: async (params: { data: ISignTemplate; docId: string }) => {
    try {
      const paramsToSend = { data: params.data, docId: params.docId };
      const response = await http.cleanPost('/signdoc/requestsign', paramsToSend);
      return response;
    } catch (error) {
      console.error('error', error);
      return 'invalidFile';
    }
  },
  uploadSignedFile: async (docId: string, reqId: string, docName: string) => {
    try {
      const paramsToSend = { docId, reqId, docName };
      const response = await http.cleanGet('/signdoc/uploadsigned', paramsToSend);
      return response;
    } catch (error) {
      console.error('uploadsigned error: ', error);
      return 'invalidFile';
    }
  },
  getHtmlSignDocument: async (
    docId: string,
    locale: string,
    geoLocation: object,
    ipAddress: string,
    userAgent: string,
    metadata: object,
    quoteId: string | undefined,
    patientName: string | undefined,
    tutorEmail: string | undefined
  ) => {
    try {
      const paramsToSend = { docId, locale, geoLocation, ipAddress, userAgent, metadata, quoteId, patientName, tutorEmail };
      const response = await http.cleanPost('/signdoc/get-html-sign-doc', paramsToSend);
      return response;
    } catch (error: any) {
      console.error('SignRepository-getHtmlSignDocument(): ', error);
      return 'invalidFile';
    }
  },
  createFinalConsentSignDocs: async (docId: string, htmlSignDocContent: string) => {
    try {
      const paramsToSend = { docId, htmlSignDocContent };
      const response = await http.cleanPost('/signdoc/create-final-consent-sign-docs', paramsToSend);
      return response;
    } catch (error: any) {
      console.error('SignRepository-createFinalSignDocs(): ', error);
      return 'invalidFile';
    }
  },
  createPreConsentHtmlSignDocument: async (tutorFullName: string, tutorId: string, patientCountryId: string, patientId: string, quoteId: string | undefined) => {
    try {
      const paramsToSend = { tutorFullName, tutorId, patientCountryId, patientId, quoteId };
      const response = await http.cleanPost('/signdoc/create-pre-html-sign-doc', paramsToSend);
      return response;
    } catch (error: any) {
      console.error('SignRepository - createPreConsentHtmlSignDocument(): ', error);
      return 'invalidFile';
    }
  },
  createSignEvent: async (
    signRequestId: string,
    ipAddress: string,
    userAgent: string,
    geoLocation: object,
    metadata: object,
    eventType: string
  ) => {
    try {
      const paramsToSend = { signRequestId, ipAddress, userAgent, geoLocation, metadata, eventType };
      const response = await http.cleanPost('/signdoc/create-sign-event', paramsToSend);
      return response;
    } catch (error: any) {
      console.error('SignRepository-createSignEvent(): ', error);
      return 'invalidFile';
    }
  }
});
